import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateClientGroupMutationVariables = Types.Exact<{
  input: Types.CreateClientGroupInput;
}>;

export type CreateClientGroupMutation = {
  __typename?: 'Mutation';
  createClientGroup: {
    __typename?: 'CreateClientGroupResponse';
    message: string;
    success: boolean;
  };
};

export const CreateClientGroupDocument = gql`
  mutation CreateClientGroup($input: CreateClientGroupInput!) {
    createClientGroup(input: $input) {
      message
      success
    }
  }
`;
export type CreateClientGroupMutationFn = Apollo.MutationFunction<
  CreateClientGroupMutation,
  CreateClientGroupMutationVariables
>;
export function useCreateClientGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateClientGroupMutation,
    CreateClientGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateClientGroupMutation,
    CreateClientGroupMutationVariables
  >(CreateClientGroupDocument, options);
}
export type CreateClientGroupMutationHookResult = ReturnType<
  typeof useCreateClientGroupMutation
>;
export type CreateClientGroupMutationResult =
  Apollo.MutationResult<CreateClientGroupMutation>;
export type CreateClientGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateClientGroupMutation,
  CreateClientGroupMutationVariables
>;
